module.exports = __webpack_public_path__ + "img/iphone-map-NETHERLANDS-en.d6dace38.webp";